module.exports = __webpack_public_path__ + "img/IMG_6070_L_Foamcore.db32e1a5.jpg";